import style from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

export const AddressNameText = style.div`
    font-weight: 700 !important;
    font-size: 15px !important;
    line-height: 18px !important;
`
export const SubAddressNameText = style.div`
    font-weight: 400 !important;
    font-size: 12px !important;
    line-height: 15px !important;
`
export const SubRecommendedText = style.div`
    font-weight: 600 !important;
    font-size: 12px !important;
    line-height: 15px !important;
`
export const HealthParaNameText = style.div`
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 15px !important;
`
export const CallMessageText = style.div`
    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 17px !important;
    opacity: 0.45m !important;
`
export const SubHeadingNameText = style.div`
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 21px !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
`
export const BtnViewText = style.div`
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 17px !important;
`
export const PackSubNameText = style.div`
    font-weight: 300 !important;
    font-size: 14px !important;
    line-height: 17px !important;
`
export const PackPriceText = style.div`
    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 17px !important;
`
export const ViewCartContentText = style.div`
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 17px !important;
`
export const PackPriceNewText = style.div`
    font-weight: 600 !important;
    font-size: 13px !important;
    line-height: 17px !important;
`
export const TestNameText = style.div`
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 15px !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
`
export const CartSubSmallText = style.div`
    font-weight: 400 !important;
    font-size: 6px !important;
    line-height: 7px !important;
`
export const OrderDetailsText = style.div`
    font-weight: 500 !important;
    font-size: 15px !important;
    line-height: 18px !important;
`

export const DeliLocateText = style.div`
    font-weight: 600 !important;
    font-size: 15px !important;
    line-height: 18px !important;
`
export const ChangeLocateText = style.div`
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 17px !important;
`
export const TotalOrderareText = style.div`
    font-weight: 400 !important;
    font-size: 13px !important;
    line-height: 15px !important;
`
export const OrderDetailPriceText = style.div`
    font-weight: 300 !important;
    font-size: 13px !important;
    line-height: 16px !important;
`
export const ParamTestText = style.div`
    font-weight: 300 !important;
    font-size: 10px !important;
    line-height: 12px !important;
`
export const AllSubTestText = style.div`
    font-weight: 400 !important;
    font-size: 11px !important;
    line-height: 13px !important;
`
export const OrderFoodSubText = style.div`
    font-weight: 700 !important;
    font-size: 18px !important;
    line-height: 22px !important;
`
export const RentalDescTexct = style.div`
    font-weight: 600 !important;
    font-size: 18px !important;
    line-height: 22px !important;
`

export const FoodSubSubText = style.div`
    font-weight: 600 !important;
    font-size: 15px !important;
    line-height: 22px !important;
`

export const CartSubNameText = style.div`
    font-weight: 600 !important;
    font-size: 17px !important;
    line-height: 20px !important;
`
export const FBtnIncrText = style.div`
    font-weight: 600 !important;
    font-size: 13px !important;
    line-height: 16px !important;
`
export const BestSellBlkText = style.div`
    font-weight: 500 !important;
    font-size: 13px !important;
    line-height: 16px !important;
`

export const PricedetailsBlock = style.div`
    font-size: 17px;
    font-weight: 600;
`;
export const WarningAddtext = style.div`
    font-size: 1rem;
    font-weight: 500;
`;
export const AddDeleteWarnText = style.div`
    font-size: 14px;
    font-weight: 500;
    margin-top: 20px;
`;
export const AddAddressText = style.div`
    font-size: 16px;
    font-weight: 600;
`;
export const HealthNameeText = style.div`
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    
`;



export const DistanceText = style.div`
    font-size: 12px;
    font-weight: 500;
    margin-top: 5px;
    color: #8c8a8a;
`;
export const HomeSubHeadText = style.div`
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
`;

export const FoodNameResponsiveText = style.div`
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        @media (min-width: 390px) {
            font-size: 17px;
        }
`;

export const HealthTestHeadText = style.div`
        font-weight: 600 !important;
        font-size: 16px !important;
        line-height: 21px !important;
        text-overflow: ellipsis !important;
        overflow: hidden !important;
        white-space: nowrap !important;
`;

export const HomeBigStyleText = style.div`
        font-weight: 600;
        font-size: 42px;
        line-height: 41px;
        color: #B3ADAD;
        text-transform:capitalize;
        
        &:last-child{
            color: blue;
        }
`;

export const HomeSmallStyleText = style.div`
        font-weight: 500;
        font-size: 16px;
        line-height: 12px;
`;
export const OrderIdText = style.div`
        font-size:12px;
        font-weight:500;
        color:#808080;
`
export const OrderAmountText = style.div`
        font-size:14px;
        font-weight:700;
`
export const OrderStatusFareText = style.div`
    font-size:13px;
    font-weight:500;
    color: #1646a7;
`
export const FoodCategoryContentText = style.div`
    font-size:13px;
    font-weight:500;
`
export const AddressFullText = style.div`
    font-size:13px;
    font-weight:400;
    text-align:justify;
`
export const FoodSubHeadText = style.div`
    font-weight: 600;
    font-size: 22px;
    line-height: 16px;
`
export const FoodRestHeadText = style.div`
    font-weight: 600;
    font-size: 20px;
    line-height: 16px;
  `
export const FoodTimeDisplayText = style.div`
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
`
export const OfferOwnText = style.div`
    font-weight: 600;
    font-size: 19px;
    text-transform: uppercase;
`
export const OfferLimitText = style.div`
    font-weight: 400;
    font-size: 11px;
`
export const OfferText = style.div`
    font-weight: 700;
    font-size: 28px;
`



export const useStyles = makeStyles({
    searchIcon: {
        margin: "0px 0px 0px 8px",
        color: "#0493B3",
        height: '100px'
    },
    searchIconHomeService: {
        margin: "0px 6px 0px 8px",
        color: "#0493B3",
        height: '20px'
    },
    searchFoodIcon: {
        margin: "0px 8px 0px 8px",
        color: "#FF4040",
    },
    closeSearceHomeServiceBtn: {
        margin: "0px 8px 0px 8px",
        color: "grey",
    },
    searchHealthIcon: {
        margin: "0px 8px 0px 8px",
        height: '18px',
        width: '18px'
    },
    search_small_FoodIcon: {
        margin: "0px 8px 0px 8px",
        color: "#FF4040",
        height: '14px'
    },
    text_field_style: {
        fontSize: "15px",
        width: "100%",
        height: "100%",
        boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.05)",
        borderRadius: '10px 0px 0px 10px',
    },
    root: {
        '&$disabled $notchedOutline': {
            borderColor: 'orange'
        }
    },
    disabled: {},
    notchedOutline: {}
});
